import { createTenantScope, storeSettingsQueries } from '@ctrl/db';

import { supabase } from './supabase.ts';

/**
 * Store details for the admin.
 *
 * Runs the ported query against the browser client, so PostgREST applies the
 * policies directly: any member of the account may read
 * (`20260828040000_store_settings_read_any_member.sql`), and only
 * `settings.manage` may write. Nothing here needs a secret or service-role, so
 * it does not go through the admin API -- see `docs/authorization.md`.
 */

export type StoreSettingsValues = storeSettingsQueries.StoreSettingsValues;
export type StoreSettingsData = storeSettingsQueries.StoreSettingsData;
export type WeightUnit = storeSettingsQueries.WeightUnit;

export const WEIGHT_UNITS = storeSettingsQueries.WEIGHT_UNITS;
export const EMPTY_STORE_SETTINGS = storeSettingsQueries.EMPTY_STORE_SETTINGS;

export function getStoreSettings(accountId: string, userId: string) {
  return storeSettingsQueries.getStoreSettings(
    supabase,
    createTenantScope(accountId, 'staff-jwt'),
    userId,
  );
}

export function saveStoreSettings(accountId: string, values: StoreSettingsValues) {
  return storeSettingsQueries.saveStoreSettings(
    supabase,
    createTenantScope(accountId, 'staff-jwt'),
    values,
  );
}

export function saveTradingName(accountId: string, name: string) {
  return storeSettingsQueries.saveTradingName(
    supabase,
    createTenantScope(accountId, 'staff-jwt'),
    name,
  );
}
